import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from "@air/primitive-badge";
import { SLACK_UPGRADE_BADGE } from "~/constants/testIDs";
export const SlackUpgradeBadge = ()=>{
    return /*#__PURE__*/ _jsx(Badge, {
        color: "teal",
        className: "shrink-0",
        "data-testid": SLACK_UPGRADE_BADGE,
        children: "UPGRADE"
    });
};
